/**
*
* RedVenue
*
*/

import React from 'react';
import PropTypes from 'prop-types';

import selectVenueById from 'helpers/selectVenueById';
import setLanguageContent from 'helpers/setLanguageContent';

import Wrapper from 'components/Templates/dynamics/Wrapper';
import AddTemplateData from 'components/Templates/dynamics/AddTemplateData';
import Map from 'components/Map';



import VenuesPlaceholder from './styles/VenuesPlaceholder';

import venueImg from 'components/Templates/styles/Red/assets/JPG/venue.jpg';

class RedVenue extends React.PureComponent {


  render() {

      const {
        commonData,
        openEditor,
        commonProps,
        venues,
        defaultVenue,
        setShowPopup,
        language,
      } = this.props;

      const {
        componentPayload,        
      } = commonData;

      const {
        isEditor,
        frameRef,
        helpers
      } = commonProps;

      const {
        venueId
      } = componentPayload;

      const selectVenue = venueId || defaultVenue ? selectVenueById(venues, venueId ? venueId : defaultVenue) : '';

      const thisVenue = selectVenue ? selectVenue : venues[0];


      const addVenueContent = isEditor && !thisVenue ? (
        <AddTemplateData
          editorData={{
            editorType: 'wrapper',
            ...commonData
          }}
          helpers={helpers}
          setShowPopup={setShowPopup}
          popupValue={'venues-view'}
          title={'Manage Venues'}
        />
        
      ) : '';

      if (!venues || !thisVenue) return (
        <Wrapper
          {...commonProps}
          
          typeOfStyle={'wrapper'}
          editorData={
            {
              editorType: 'wrapper',
              ...commonData
            }
          }
        >
          <Wrapper
              {...commonProps}
              
              typeOfStyle={'wrapperWithMargin'}
              editorData={
              {
                editorType: 'wrapperWithMargin',
                ...commonData
              }
            }
          >
            {
              !isEditor ? '' : (
                <>
                  <VenuesPlaceholder>
                    <span>
                      Select venue in edit section in order to display venue informations.         
                    </span>
                  </VenuesPlaceholder>
                  <br />
                  <br />
                  {addVenueContent}
              </>
              )
            }
          </Wrapper>
        </Wrapper>
      );

      const addVenueIcons = thisVenue ? (
        <Wrapper
          {...commonProps}
          typeOfStyle={'venueIcons'}
          
          editorData={
            {
              editorType: 'venueIcons',
              ...commonData
            }
          }
        >

          {
            thisVenue.linkedin ? (
              <Wrapper
                {...commonProps}
                typeOfStyle={'venueLinkedinIcon'}
                
                href={thisVenue.linkedin.startsWith('http') ? thisVenue.linkedin : `https://${thisVenue.linkedin}`}
                target={'_blank'}
                editorData={
                    {
                      editorType: 'venueLinkedinIcon',
                      ...commonData
                    }
                  }
              />
            ) : ''
          }
          {
            thisVenue.facebook ? (
              <Wrapper
                {...commonProps}
                typeOfStyle={'venueFacebookIcon'}
                
                href={thisVenue.facebook.startsWith('http') ? thisVenue.facebook : `https://${thisVenue.facebook}`}
                target={'_blank'}
                editorData={
                    {
                      editorType: 'venueFacebookIcon',
                      ...commonData
                    }
                  }
              />
            ) : ''
          }

          {
            thisVenue.instagram ? (
              <Wrapper
                {...commonProps}
                typeOfStyle={'venueInstagramIcon'}
                
                href={thisVenue.instagram.startsWith('http') ? thisVenue.instagram : `https://${thisVenue.instagram}`}
                target={'_blank'}
                editorData={
                    {
                      editorType: 'venueInstagramIcon',
                      ...commonData
                    }
                  }
              />
            ) : ''
          }

          {
            thisVenue.twitter ? (
              <Wrapper
                {...commonProps}
                typeOfStyle={'venueTwitterIcon'}
                
                href={thisVenue.twitter.startsWith('http') ? thisVenue.twitter : `https://${thisVenue.twitter}`}
                target={'_blank'}
                editorData={
                    {
                      editorType: 'venueTwitterIcon',
                      ...commonData
                    }
                  }
              />
            ) : ''
          }

          {
            thisVenue.website ? (
              <Wrapper
                {...commonProps}
                typeOfStyle={'venueWebIcon'}
                
                href={thisVenue.website.startsWith('http') ? thisVenue.website : `https://${thisVenue.website}`}
                target={'_blank'}
                editorData={
                  {
                    editorType: 'venueWebIcon',
                    ...commonData
                  }
                }
              />
            ) : ''
          }
        </Wrapper>
        
      ) : '';

      return (
        <>
          <Wrapper
            {...commonProps}
            
            typeOfStyle={'wrapper'}
            editorData={
            {
              editorType: 'wrapper',
              ...commonData
            }
          }
          >
            <Wrapper
              {...commonProps}
              
              typeOfStyle={'wrapperWithMargin'}
              editorData={
              {
                editorType: 'wrapperWithMargin',
                ...commonData
              }
            }
            >
              <Wrapper
                {...commonProps}
                
                typeOfStyle={'columnsWrapper'}
                editorData={
                {
                  editorType: 'columnsWrapper',
                  ...commonData
                }
              }
              >
                <Wrapper
                  {...commonProps}
                  
                  typeOfStyle={'columnDescription'}
                  editorData={
                  {
                    editorType: 'columnDescription',
                    ...commonData
                  }
                }
                >

                  {thisVenue.title ? (<Wrapper
                    {...commonProps}
                    
                    typeOfStyle={'title'}

                    editorData={
                      {
                        editorType: 'title',
                        ...commonData
                      }
                    }
                  >{setLanguageContent(thisVenue, 'title', language)}</Wrapper>) : ''}

                  {thisVenue.description ? (<Wrapper
                    {...commonProps}
                    
                    typeOfStyle={'description'}

                    editorData={
                      {
                        editorType: 'description',
                        ...commonData
                      }
                    }
                  >{setLanguageContent(thisVenue, 'description', language)}</Wrapper>) : ''}


                  {thisVenue.address ? (<Wrapper
                    {...commonProps}
                    
                    typeOfStyle={'address'}

                    editorData={
                      {
                        editorType: 'address',
                        ...commonData
                      }
                    }
                  >{setLanguageContent(thisVenue, 'address', language)}</Wrapper>) : ''}

                  {thisVenue.zip ? (<Wrapper
                    {...commonProps}
                    
                    typeOfStyle={'zip'}
                    defaultValues={thisVenue}

                    editorData={
                      {
                        editorType: 'zip',
                        ...commonData
                      }
                    }
                  >{setLanguageContent(thisVenue, 'zip', language)}</Wrapper>) : ''}

                  {thisVenue.city ? (<Wrapper
                    {...commonProps}
                    
                    typeOfStyle={'city'}
                    defaultValues={thisVenue}

                    editorData={
                      {
                        editorType: 'city',
                        ...commonData
                      }
                    }
                    >{setLanguageContent(thisVenue, 'city', language)}</Wrapper>) : ''}
     
                  {thisVenue.country ? (<Wrapper
                    {...commonProps}
                    
                    typeOfStyle={'country'}
                    defaultValues={thisVenue}
                    editorData={
                      {
                        editorType: 'country',
                        ...commonData
                      }
                    }
                  >{setLanguageContent(thisVenue, 'country', language)}</Wrapper>) : ''}

                  {addVenueIcons}
                </Wrapper>
                <Wrapper
                  {...commonProps}
                  
                  typeOfStyle={'columnImage'}
                  backgroundImage={thisVenue && thisVenue.image ? thisVenue.image : venueImg}
                  editorData={
                    {
                      editorType: 'columnImage',
                      ...commonData
                    }
                  }
                />
              </Wrapper>
                {
                   thisVenue && thisVenue.venueMap ? (
                    <Wrapper
                      {...commonProps}
                      
                      typeOfStyle={'map'}
                      editorData={
                        {
                          editorType: 'map',
                          ...commonData
                        }
                      }
                    >
                      <Map
                        viewport={thisVenue.venueMap ? thisVenue.venueMap : null} 
                        scrollZoom={false}
                        dragPan={false}
                        height={400}
                        windowWidth={commonProps.windowWidth}
                        frameRef={frameRef}
                      />
                    </Wrapper>
                   ) : ''
                }
              {addVenueContent}
            </Wrapper>
          </Wrapper>
        </>
      );

  }

}

RedVenue.propTypes = {
  commonData: PropTypes.object,
  openEditor: PropTypes.func,
  commonProps: PropTypes.object,
  defaultValues: PropTypes.object,
};

export default RedVenue;
